import normalize from 'json-api-normalizer';
import Survey from './survey';
import Stage from './stage';

export default class SurveyLink {
	static from (jsonapi) {
		let key = 'surveyLinks'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = SurveyLink.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return SurveyLink.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi, noRelationships=0) {
		const { id, attributes } = jsonapi;

		let relationships = {}
		if (normalizedJSONapi['surveys'] && normalizedJSONapi['surveys'][attributes['surveyId']] && noRelationships == 0) {
			relationships['survey'] = Survey.make(normalizedJSONapi['surveys'][attributes['surveyId']], normalizedJSONapi);
		}

		if (normalizedJSONapi['stages'] && normalizedJSONapi['stages'][attributes['stageId']] && noRelationships == 0) {
			relationships['stage'] = Stage.make(normalizedJSONapi['stages'][attributes['stageId']], normalizedJSONapi, 1);
		}

		return new SurveyLink ( Object.assign({id: id}, attributes, relationships) );
	}

	constructor ({ id, position, stageId, stage, displayTitle, version, activatesIn, expiresIn, surveyId, survey, varnamePrefix, varnameSuffix, disabled}) {
		this.id            = id ? id : -1;
		this.position      = position ? position : 0;
		this.stage_id      = stageId ? stageId : null;
		this.stage         = stage ? stage : null;
		this.display_title = displayTitle ? displayTitle : null;
		this.version       = version ? version : 0;
		this.activates_in  = activatesIn ? activatesIn : 0;
		this.expires_in    = expiresIn ? expiresIn : 0;
		this.survey_id     = surveyId ? surveyId : null;
		this.survey        = survey ? survey : null;
		this.varname_prefix = varnamePrefix ? varnamePrefix : null;
		this.varname_suffix = varnameSuffix ? varnameSuffix : null;
		this.disabled 			= disabled ? disabled : false;
	}

	toJSONapi () {
		let attributes = Object.assign({}, this);
		attributes["survey_id"] = this.survey.id;
		delete attributes.id;
		delete attributes.survey;

		return {data: {type: "survey_links", id: this.id, attributes: attributes}};
	}

	displayName() {
		return ((this.stage)?this.stage.name + ' - ' : '') + ((this.display_title)? this.display_title : this.survey.title);
	}

	title() {
		return (this.display_title) ? this.display_title : ((this.survey) ? this.survey.title : '<<UNKNOWN>>' )
	}
}
